import styled from 'styled-components'
import { device } from '../../../theme'

export const SectionWrap = styled.div`
    position: relative;
    padding-top: 150px;
    padding-bottom: 150px;
    @media ${device.medium} {
        padding-top: 100px;
        padding-bottom: 100px;
    }
`;